/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDiscounts48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M24.5 45.75c12.012 0 21.75-9.738 21.75-21.75S36.512 2.25 24.5 2.25 2.75 11.988 2.75 24s9.738 21.75 21.75 21.75z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M17.898 20.648a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM31.102 33.852a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM13.236 35.264l22.527-22.528'
      />
    </svg>
  );
}

export default SvgDiscounts48;
